module.exports = __webpack_public_path__ + "img/news1-4.545dfb6b.png";